﻿import { startLoadingAnimation } from "#ofcas/odid/webpack/js/components/button-loading-animations/functions.js";

const buttons = document.querySelectorAll('[spam-protected]');

buttons.forEach(element => element.addEventListener('click', function (event) {
    if (!element.hasAttribute('aria-disabled') || element.ariaDisabled === "false") {
        startLoadingAnimation(element);
    }
    else {
        event.preventDefault();
    }
}));
